import { render, staticRenderFns } from "./Page021.vue?vue&type=template&id=0969717b&scoped=true&"
import script from "./Page021.vue?vue&type=script&lang=js&"
export * from "./Page021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969717b",
  null
  
)

export default component.exports